import {
  FC,
  ReactNode,
  useState,
  useMemo,
  useCallback,
  createContext,
} from "react";

type SidebarContext = {
  sidebarToggle: any;
  toggleSidebar: () => void;
  closeSidebar: () => void;
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SidebarContext = createContext<SidebarContext>(
  {} as SidebarContext
);

type SidebarProviderProps = {
  children: ReactNode;
};

export const SidebarProvider: FC<SidebarProviderProps> = ({ children }) => {
  const [sidebarToggle, setSidebarToggle] = useState(false);
  const toggleSidebar = useCallback(() => {
    setSidebarToggle((prev) => !prev);
  }, []);
  const closeSidebar = useCallback(() => {
    setSidebarToggle(false);
  }, []);

  const value = useMemo(
    () => ({ sidebarToggle, toggleSidebar, closeSidebar }),
    [sidebarToggle, toggleSidebar, closeSidebar]
  );

  return (
    <SidebarContext.Provider value={value}>
      {children}
    </SidebarContext.Provider>
  );
};
